import { render, staticRenderFns } from "./IconExternalLinkSolid.vue?vue&type=template&id=56cd7077"
import script from "./IconExternalLinkSolid.vue?vue&type=script&lang=js"
export * from "./IconExternalLinkSolid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports